



































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';
import Routes from '@/util/Routes';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import AddressList from '@/views/account/user/AddressList.vue';
import { DateFormatter } from '@/util/DateFormatter';
import KeycloakService from '@/services/KeycloakService';
import ProfileMegacardWidget from '@/views/account/user/ProfileMegacardWidget.vue';

@Component({
  components: {ProfileMegacardWidget, AddressList, LoadingIndicator},
})
export default class UserProfile extends Vue {
  public userStore = getModule(UserStore, this.$store);
  public pageSize = this.userStore.currentPageSize;
  public routes = Routes;

  public async update() {
    await this.userStore.savePageSize();
  }

  private get userPageSize() {
    return this.userStore.currentPageSize;
  }

  private get currentUser() {
    return this.userStore.currentUser;
  }

  private get currentUserBirthDate() {
    const birthDate = this.currentUser?.birthDate;
    if (birthDate) {
      return DateFormatter.formatBirthDate(new Date(birthDate));
    }
    return '';
  }

  private get keycloakPasswordChangeUrl() {
    return KeycloakService.getChangePasswordUrl(this.userStore.currentLanguage);
  }
}
